<template>
	<v-skeleton-loader v-if="isLoading" type="card"></v-skeleton-loader>
	<PostForm v-else :post="normalizedPost" />
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import PostForm from '@/components/Forms/PostForm'
import moment from 'moment'

export default {
	name: 'PostEditPage',
	components: {
		PostForm,
	},
	methods: {
		...mapActions('post', ['getPost']),
	},
	computed: {
		...mapGetters('post', ['isLoading', 'post']),
		normalizedPost() {
			let {
				title = '',
				content = '',
				categories = [],
				tags = [],
				created_at = '',
				latitude = 0,
				longitude = 0,
				locationName = '',
			} = this.post

			categories = categories.map((item) => item.id)
			tags = tags.map((item) => item.id)
			const lat = parseFloat(latitude)
			const long = parseFloat(longitude)

			return {
				title,
				content,
				categories,
				tags,
				date: moment(created_at).format('MMMM DD'),
				lat,
				long,
				address: locationName,
			}
		},
	},
	created() {
		if (this.$route.params.id !== undefined) {
			this.getPost(this.$route.params.id)
		}
	},
}
</script>
